/**
 * Detect law-enforcement / government subscription vs corporate.
 * Aligns with `Subscriptions` plan ids (LEO-*) and stored `category` on company documents.
 */
export function isLawEnforcementPlan(subscriptionPlan: unknown): boolean {
  if (subscriptionPlan == null || typeof subscriptionPlan !== 'object') {
    return false;
  }
  const p = subscriptionPlan as Record<string, unknown>;
  const id = String(p.id ?? '');
  if (id.startsWith('LEO')) {
    return true;
  }
  const cat = p.category;
  if (cat === 'law-enforcement' || cat === 'law') {
    return true;
  }
  if (typeof p.maxSites === 'number' && p.maxSites === 0) {
    return true;
  }
  const sku = String(p.sku ?? '').toLowerCase();
  if (sku.includes('leo') || sku.includes('law')) {
    return true;
  }
  return false;
}
